export function getSelectedInsuranceSaveCodes(insurances = [], availableInsuranceCodes) {
    if (!insurances.length) {
        return [];
    }
    const selectedSaveServicesCodesSet = new Set();
    insurances.forEach(insurance => {
        const selectedCodes = insurance.selectedPrograms;
        selectedCodes.forEach(code => {
            // filter by available insurance programs
            if (!(availableInsuranceCodes === null || availableInsuranceCodes === void 0 ? void 0 : availableInsuranceCodes.length) || availableInsuranceCodes.includes(code)) {
                selectedSaveServicesCodesSet.add(code);
            }
        });
    });
    return [...selectedSaveServicesCodesSet];
}
export const getImportantInsuranceCodesByAvailableCodes = (insurancePrograms, availableInsuranceCodes = []) => {
    var _a;
    const importantInsuranceCodeSet = new Set();
    (_a = insurancePrograms === null || insurancePrograms === void 0 ? void 0 : insurancePrograms.insurancePrograms) === null || _a === void 0 ? void 0 : _a.forEach(insuranceProgram => {
        if (!(insuranceProgram === null || insuranceProgram === void 0 ? void 0 : insuranceProgram.code)) {
            return;
        }
        if (insuranceProgram.important &&
            (!availableInsuranceCodes.length || availableInsuranceCodes.includes(insuranceProgram.code))) {
            importantInsuranceCodeSet.add(insuranceProgram.code);
        }
    });
    return [...importantInsuranceCodeSet];
};
